import jQuery from 'jquery';
import React from 'react';
import { cn } from 'src/frames/utils/cn';
import './PaginatingDiv.scss';

type PropsT = React.PropsWithChildren<{
  pageNr: number;
  id?: string;
  className?: any;
}>;

export const PaginatingDiv = (props: PropsT) => {
  const elmRef = React.useRef(null);
  const elm = elmRef.current as any;

  React.useEffect(() => {
    if (elm) {
      jQuery(elm).animate({
        scrollTop: props.pageNr * (elm.clientHeight - 40),
      });
    }
  }, [elm, props.pageNr]);
  return (
    <div
      id={props.id}
      className={cn('PaginatingDiv', 'flex-1', props.className)}
      ref={elmRef}
    >
      <div className="PaginatingDiv__Inner">{props.children}</div>
    </div>
  );
};
